import { Button } from '@/view/shared/Button';
import { useQuotaBannerViewModel } from '@/viewmodel/features/quota';
import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

export function QuotaBanner(): ReactNode {
  const { lines, planActionLabel, openPlanAction } = useQuotaBannerViewModel();

  if (lines.length === 0) return null;

  return (
    <div
      role="alert"
      data-testid="quota-banner"
      className="shrink-0 flex flex-col gap-2 border-b border-warning/40 bg-warning/5 px-4 py-3 sm:flex-row sm:items-center sm:px-6 md:px-8 lg:px-16"
    >
      <AlertTriangle size={16} className="shrink-0 text-warning" />
      <div className="flex flex-1 flex-col gap-1">
        {lines.map((line) => (
          <p key={line.key} className="text-xs text-foreground">
            {line.text}
          </p>
        ))}
      </div>
      <Button variant="secondary" size="sm" onClick={openPlanAction} className="shrink-0">
        {planActionLabel}
      </Button>
    </div>
  );
}
